import React from "react";
import { Common } from "../../assets/images";

interface Props {
  children: React.ReactNode;
  type: string;
  customImage?: boolean;
  bgLogo?: string;
  savedBGImage?: string;
  bgImage?: boolean;
  companyNameEnglish?: string;
  companyNameArabic?: string;
  companyPhone?: string;
  companyWebsite?: string;
  companyEmail?: string;
  companyAddress?: string;
}

const InvoiceFormat = ({
  children,
  type,
  customImage,
  bgLogo,
  savedBGImage,
  bgImage,
  companyNameEnglish,
  companyNameArabic,
  companyPhone,
  companyWebsite,
  companyEmail,
  companyAddress,
}: Props) => {
  const letterContentStyle: React.CSSProperties = {
    backgroundImage: `url(${savedBGImage})`,
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "80%",
    opacity: "0.15",
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    zIndex: "0",
  };
  return (
    <>
      <div className="letter-format-a letter-format-b">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <img src={Common.Vision} width="110px" alt="logo" />
          </div>
          <div className="letter-logo text-center gap-2">
            <img
              src={customImage ? bgLogo : Common.LogoSVG}
              width="80px"
              alt="logo"
            />
            <div className="mt-1">
              <h3
                className="logo-text mb-0"
                style={{
                  color: "#202020",
                  fontSize: "10px",
                  fontWeight: "700",
                }}
              >
                {customImage
                  ? companyNameEnglish
                    ? companyNameEnglish
                    : "Senyarsa Trading Company Ltd."
                  : "Senyarsa Trading Company Ltd."}
              </h3>
              <h3
                className="logo-text logo-arabic mb-0"
                style={{
                  color: "#202020",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                {customImage
                  ? companyNameArabic
                    ? companyNameArabic
                    : "شركة سنيار العربية التجارية المحدودة"
                  : "شركة سنيار العربية التجارية المحدودة"}
              </h3>
            </div>
          </div>
        </div>
        {type === "payslip" ? null : (
          <h4
            className="heading text-center text-uppercase mb-0"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            {type === "Invoice" ? "فاتورة ضريبية" : "الإشعارالدائن"}
          </h4>
        )}
        <h4
          className="heading text-center text-uppercase"
          style={{ textAlign: "center", fontSize: "18px" }}
        >
          {type === "payslip"
            ? "Payslip"
            : type === "Invoice"
              ? "Tax Invoice"
              : "Credit Note"}
        </h4>

        <>
          {customImage ? (
            bgImage ? (
              savedBGImage ? (
                <div className="letter-content-b mt-3">
                  <div
                    style={
                      customImage
                        ? bgImage
                          ? savedBGImage
                            ? letterContentStyle
                            : {}
                          : {}
                        : {}
                    }
                  ></div>
                  <div className="letter-body">{children}</div>
                </div>
              ) : (
                <div className="letter-content letter-content-b mt-3">
                  <div className="letter-body">{children}</div>
                </div>
              )
            ) : (
              <div className="letter-content-b mt-3">
                <div className="letter-body">{children}</div>
              </div>
            )
          ) : (
            <div className="letter-content letter-content-b mt-3">
              <div className="letter-body">{children}</div>
            </div>
          )}
        </>
      </div>
      <div
        className="compnay-detail "
        style={{ position: "absolute", bottom: "14px", left: "0px" }}
      >
        <div className="d-flex align-items-center justify-content-end mb-1">
          <span style={{ fontSize: "12px" }}>:</span>
          <h4
            className="sub-heading ms-1 mb-0 text-black text-end"
            style={{ fontSize: "12px" }}
          >
            الرقم الموحد
          </h4>
        </div>
        <div style={{ background: "rgb(0 0 0)", padding: "4px 30px" }}>
          <h4
            className="sub-heading text-white mb-0 ms-4"
            style={{ fontSize: "22px" }}
          >
            {customImage
              ? companyPhone
                ? companyPhone
                : "9200 14 811"
              : "9200 14 811"}
          </h4>
        </div>
        <h4
          className="sub-heading ms-2 text-black mb-0 text-center"
          style={{ fontSize: "10px", letterSpacing: "2px" }}
        >
          {customImage
            ? companyWebsite
              ? companyWebsite
              : "www.senyarsa.com"
            : "www.senyarsa.com"}
        </h4>
      </div>
      <div
        className="compnay-detail d-flex justify-content-end"
        style={{ position: "absolute", bottom: "14px", right: "24px" }}
      >
        <div style={{ width: "1px", border: "1px solid #0000005e" }}></div>
        <ul className="ms-3">
          {customImage ? (
            companyAddress ? (
              <>
                <li className="d-flex align-items-center gap-2 mb-1">
                  <span
                    className="sub-heading normal-font-weight text-black mb-0"
                    style={{ fontSize: "12px" }}
                  >
                    K.S.A.
                  </span>
                  <h4
                    className="sub-heading ms-2 normal-font-weight text-black mb-0"
                    style={{ fontSize: "12px", wordSpacing: "10px" }}
                  >
                    {companyAddress}
                  </h4>
                </li>
              </>
            ) : (
              <>
                <li className="d-flex align-items-center gap-2 mb-1">
                  <span
                    className="sub-heading normal-font-weight text-black mb-0"
                    style={{ fontSize: "12px" }}
                  >
                    K.S.A.
                  </span>
                  <h4
                    className="sub-heading ms-2 normal-font-weight text-black mb-0"
                    style={{ fontSize: "12px", wordSpacing: "10px" }}
                  >
                    P.O Box 8931 Jeddah 23345
                  </h4>
                </li>
                <li className="d-flex align-items-center gap-2 mb-1">
                  <span
                    className="sub-heading normal-font-weight text-black mb-0"
                    style={{ fontSize: "12px" }}
                  >
                    Jeddah -
                  </span>
                  <h4
                    className="sub-heading normal-font-weight text-black mb-0"
                    style={{ fontSize: "12px", wordSpacing: "2px" }}
                  >
                    Jamil bin moamer St, AlRehab
                  </h4>
                </li>
              </>
            )
          ) : (
            <>
              <li className="d-flex align-items-center gap-2 mb-1">
                <span
                  className="sub-heading normal-font-weight text-black mb-0"
                  style={{ fontSize: "12px" }}
                >
                  K.S.A.
                </span>
                <h4
                  className="sub-heading ms-2 normal-font-weight text-black mb-0"
                  style={{ fontSize: "12px", wordSpacing: "10px" }}
                >
                  P.O Box 8931 Jeddah 23345
                </h4>
              </li>
              <li className="d-flex align-items-center gap-2 mb-1">
                <span
                  className="sub-heading normal-font-weight text-black mb-0"
                  style={{ fontSize: "12px" }}
                >
                  Jeddah -
                </span>
                <h4
                  className="sub-heading normal-font-weight text-black mb-0"
                  style={{ fontSize: "12px", wordSpacing: "2px" }}
                >
                  Jamil bin moamer St, AlRehab
                </h4>
              </li>
            </>
          )}
          <li className="d-flex align-items-center gap-2 mb-1">
            <span
              className="sub-heading normal-font-weight text-black mb-0"
              style={{ fontSize: "12px" }}
            >
              E-mail:
            </span>
            <h4
              className="sub-heading normal-font-weight text-black mb-0 ms-3"
              style={{ fontSize: "12px", letterSpacing: "4px" }}
            >
              {customImage
                ? companyEmail
                  ? companyEmail
                  : "info@senyarsa.com"
                : "info@senyarsa.com"}
            </h4>
          </li>
        </ul>
      </div>
    </>
  );
};
export default InvoiceFormat;
